import request from 'superagent'

export default class Gateway
{
    constructor()
    {
        if (Gateway._instance)
        {
            return Gateway._instance
        }

        Gateway._instance = this
    }

    static getInstance()
    {
        if (!Gateway._instance)
        {
            Gateway._instance = new Gateway()
        }

        return Gateway._instance
    }

    /* eslint-disable class-methods-use-this */
    send(method, url, data = {}, onSuccess, onError)
    {
        // Try the return data before callback
        const onLoad = (error, respond) =>
        {
            if (error || !respond || !respond.ok || !respond.body)
            {
                const finalURL = (respond && respond.req && respond.req.url) ? respond.req.url : url
                onError(`Can not load the API data: ${finalURL}`)
            }
            else
            {
                const json = respond.body
                onSuccess(json)
            }
        }

        // AJAX request with superagent
        if (method.toLowerCase() === 'post')
        {
            request
                .post(url)
                .type('form')
                .send(data)
                .end(onLoad)
        }
        else if (method.toLowerCase() === 'get')
        {
            request
                .get(url)
                .query(data)
                .end(onLoad)
        }
        else if (method.toLowerCase() === 'put' || method.toLowerCase() === 'patch')
        {
            request
                .put(url)
                .type('form')
                .send(data)
                .end(onLoad)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/utils/global/Gateway.js